function ProfileCtrl($state, $stateParams, $auth, $rootScope, toaster, ProfileService, CommonService) {
  'ngInject';
  // ViewModel
  const vm = this;
  vm.responseReceived = false;
  vm.profileForm = {};
  vm.passwordForm = {};
  vm.init = function () {
    //to hide the organization name
    $rootScope.organizationNameView = false;
      ProfileService.getProfile(function(response) {
        vm.currentUser = response.data;
        vm.profileForm = vm.currentUser;
      });
  };

  vm.updateUser = function(profileForm){
      vm.responseReceived = false;
      ProfileService.updateUser(vm.profileForm, vm.currentUser.id, function(response) {
      vm.responseReceived = true;
      profileForm.$setPristine();
      profileForm.$setUntouched();
        if(response.status == 200)
        {  $rootScope.$emit("user_updated",response.data);
         toaster.pop('info', 'Profile updated sucessfully');
          $state.go('user.profile',{inherited: false});
        }else {
          toaster.pop('error', CommonService.throwError(response));
        }
      });
  }
  vm.editProfile = function(userid) {
    $state.go('user.profile-edit', {orgId: $stateParams.orgId, userid: userid },{inherited: false});
  };

  vm.openForm = function() {
    $('#password_form').collapse('show');
    $('html,body').animate({
     scrollTop: $("#password_form > form").offset().top
    }, 500);
    $('#password_form').collapse('hide');
    vm.passwordForm = {};
 };

  vm.resetPassword = function(passwordForm){
    ProfileService.resetPassword(vm.passwordForm, function(response) {
        $('#password_form').collapse('hide');
         if (response.status >= 200 & response.status < 300)
        {
          vm.passwordForm = {};
          passwordForm.$setPristine();
          passwordForm.$setUntouched();
         toaster.pop('info', 'Password updated successfully.');
        }else {
          toaster.pop('error', CommonService.throwError(response));
        }
    });
  }

}

export default {
  name: 'ProfileCtrl',
  fn: ProfileCtrl
};
